import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class UserProfileBookmarkService {

  constructor(private apiService: ApiService,) { }

    // Commands
  getBookmarkByUser() {
    return this.apiService.queryWithPromise<any>('userProfileBookmarks/getBookmarkByUser');
  }

  // Need pathName, color, description
  addUpdateBookmark(command) {
      return this.apiService.command('UserProfileAddBookmark', command);
  }

  // ProfileId can be found inside the handler. Only need the PathName.
  bookmarkDelete(command) {
      command.WorkflowPendingTaskId = -1;
      return this.apiService.command('UserProfileDeleteBookmark', command);
  }

}
